import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import RangeSliderProps from './RangeSliderProps'

import Tooltip from '../Common/Tooltip'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: RangeSliderProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Tooltip
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoRangeSlider(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function () {
            if(that.v3){
                that.$emit('update:modelValue', that.kendoWidget().value())
            } else {
                that.$emit('changemodel', that.kendoWidget().value())
            }
        })

        that.kendoWidget().bind('slide', function () {
            if(that.v3){
                if(that.getListeners()['onUpdate:modelValue']){
                    that.$emit('update:modelValue', that.kendoWidget().value())
                }
            } else {
                that.$emit('changemodel', that.kendoWidget().value())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoRangeSlider()
        }
    },
    computed: {
        nameAttr() {
            return this.$attrs.name
        },
        selectionStartName() {
            var nameAttr = this.nameAttr
            return nameAttr ? nameAttr + '[0]' : null
        },
        selectionEndName() {
            var nameAttr = this.nameAttr
            return nameAttr ? nameAttr + '[1]' : null
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoRangeSlider/KendoRangeSliderMixin.js